export default __webpack_public_path__ + "static/media/Move.e26d185c.mp3";